import { getGroupMetadataFromEvent } from '@/lib/event-metadata'
import { useAtomValue } from 'jotai'
import { autoLoadMediaAtom } from '@/atoms/preferences'
import { Event } from '@nostr/tools/wasm'
import { useMemo } from 'react'
import ClientSelect from '../ClientSelect'
import Image from '../Image'

export default function GroupMetadata({
  event,
  originalNoteId,
  className
}: {
  event: Event
  originalNoteId?: string
  className?: string
}) {
  const autoLoadMedia = useAtomValue(autoLoadMediaAtom)
  const metadata = useMemo(() => getGroupMetadataFromEvent(event), [event])

  const groupNameComponent = (
    <div className="text-xl font-semibold line-clamp-1">{metadata.name}</div>
  )

  const groupAboutComponent = metadata.about && (
    <div className="text-sm text-muted-foreground line-clamp-2">{metadata.about}</div>
  )

  return (
    <div className={className}>
      <div className="flex gap-4">
        {metadata.picture && autoLoadMedia && (
          <Image
            imageUrl={metadata.picture}
            imagePubkey={event.pubkey}
            className="aspect-square bg-foreground h-20"
            hideIfError
          />
        )}
        <div className="flex-1 w-0 space-y-1">
          {groupNameComponent}
          {groupAboutComponent}
        </div>
      </div>
      <ClientSelect className="w-full mt-2" event={event} originalNoteId={originalNoteId} />
    </div>
  )
}
